const fr = {
  code: "fr",
  nav: { book: "Réserver", whatsapp: "WhatsApp", menu: "Menu" },
  hero: {
    eyebrow: "Tenerife · Côte sud · Départs quotidiens",
    lines: ["Les meilleures excursions de Tenerife,", "réservées en une minute."],
    sub: "Disponibilités en direct, paiement immédiat et votre bon avec QR code dans votre boîte mail avant d'avoir reposé le téléphone.",
    ctaBook: "Réserver en ligne",
    ctaWa: "Écrire sur WhatsApp",
    trust: ["Annulation gratuite", "Confirmation immédiate", "Bon avec QR code", "Paiement par carte sécurisé"],
    scroll: "Défiler",
  },
  marquee: ["Disponibilités en direct", "Payez en moins d'une minute", "Bon QR par e-mail", "Annulation gratuite jusqu'à 24 h", "Équipe locale, petits groupes", "4,9 selon 2 300 clients"],
  trips: {
    eyebrow: "Excursions du jour",
    title: "Trois excursions. De vraies dates. Zéro attente.",
    sub: "Chaque date affichée est réellement libre. Choisissez, payez, et votre bon est en route.",
    perPerson: "par personne",
    duration: "Durée",
    departs: "Départ",
    included: "Ce qui est inclus",
    pickDate: "Choisir une date",
    people: "Personnes",
    total: "Total",
    pay: "Payer",
    payNow: "Payer et recevoir le bon",
    free: "Libre",
    few: "Dernières places",
    full: "Complet",
    spotsLeft: "places libres",
    selectDateFirst: "Choisissez une date libre pour continuer",
    hours: "heures",
    meeting: "Point de rendez-vous",
    live: "Disponibilités en direct",
    items: {
      jetski: {
        title: "Safari en Jet Ski",
        tagline: "Deux heures à longer la côte sud sur votre propre jet ski, guidé du début à la fin.",
        includes: ["Jet ski individuel (1–2 pilotes)", "Guide qualifié et briefing", "Combinaison, gilet et casiers", "Photos de votre sortie"],
        meeting: "Puerto Colón, Ponton 3",
      },
      catamaran: {
        title: "Catamaran Baleines et Dauphins",
        tagline: "Trois heures de navigation avec les globicéphales résidents, pause baignade et déjeuner à bord.",
        includes: ["Observation garantie", "Déjeuner, boissons et fruits", "Pause baignade et snorkeling", "Prise en charge à l'hôtel dans le sud"],
        meeting: "Port de Los Cristianos, Porte B",
      },
      teide: {
        title: "Teide : Coucher de soleil et Étoiles",
        tagline: "Cinq heures au-dessus des nuages : coucher de soleil au bord du cratère, puis le ciel avec un guide Starlight.",
        includes: ["Minibus climatisé", "Guide astronome et télescopes", "Chocolat chaud et couverture", "Prise en charge et retour à l'hôtel"],
        meeting: "Prise en charge à votre hôtel",
      },
    },
  },
  payment: {
    title: "Paiement sécurisé",
    sub: "Payez par carte. Votre bon avec QR code arrive dans votre boîte mail dès que le paiement est validé.",
    name: "Nom complet",
    email: "E-mail pour le bon",
    card: "Numéro de carte",
    expiry: "Expiration",
    cvc: "CVC",
    pay: "Payer",
    processing: "Confirmation de votre date…",
    secure: "Chiffrement 256 bits · Protégé par 3-D Secure",
    demo: "Paiement de démonstration : aucune carte ne sera débitée.",
    summary: "Récapitulatif",
    error: "Une erreur est survenue. Veuillez réessayer.",
    dateGone: "Cette date vient d'être complète. Choisissez-en une autre.",
    freeCancel: "Annulation gratuite jusqu'à 24 heures avant le départ",
  },
  voucher: {
    eyebrow: "Paiement confirmé",
    title: "C'est réservé.",
    sent: "Votre bon a été envoyé à",
    code: "Code de réservation",
    show: "Présentez ce QR code au point de rendez-vous",
    date: "Date",
    time: "Heure",
    people: "Personnes",
    paid: "Payé",
    meeting: "Point de rendez-vous",
    download: "Télécharger le bon",
    done: "Terminé",
    bookAnother: "Réserver une autre excursion",
  },
  how: {
    eyebrow: "Comment ça marche",
    title: "Trois étapes, une minute.",
    steps: [
      { t: "Choisissez une date libre", d: "Le calendrier affiche ce qui est réellement disponible aujourd'hui. Si c'est vert, c'est à vous." },
      { t: "Payez par carte", d: "Apple Pay, Google Pay ou toute carte. Vos places sont bloquées à la seconde où vous payez." },
      { t: "Votre bon arrive", d: "Un bon avec QR code arrive aussitôt par e-mail. Montrez-le sur votre téléphone et c'est parti." },
    ],
  },
  reviews: {
    eyebrow: "Avis clients",
    title: "Ce qu'ils disent au retour.",
    items: [
      { name: "Hannah Whitmore", place: "Manchester, Royaume-Uni", trip: "Safari en Jet Ski", text: "Réservé au petit-déjeuner, sur l'eau à dix heures et demie. Le bon est arrivé avant la fin de mon café. Le guide était génial et les photos sont incroyables." },
      { name: "Lukas Brandt", place: "Hambourg, Allemagne", trip: "Catamaran Baleines et Dauphins", text: "Nous avons vu des globicéphales en vingt minutes. Déjeuner à bord, baignade dans une crique tranquille, aucune foule. L'enregistrement par QR a pris trois secondes." },
      { name: "Chiara Moretti", place: "Milan, Italie", trip: "Teide : Coucher de soleil et Étoiles", text: "Le coucher de soleil au-dessus des nuages valait déjà le détour, puis les étoiles. Notre guide savait tout. La prise en charge était à l'heure, à la minute près." },
    ],
    verified: "Réservation vérifiée",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Bon à savoir.",
    items: [
      { q: "Qu'est-ce qui est inclus dans le prix ?", a: "Tout ce qui figure sur la fiche de l'excursion : équipement, guide, assurance et le repas ou la prise en charge mentionnés. Aucun frais de réservation, aucune surprise au point de rendez-vous." },
      { q: "Puis-je annuler ou changer de date ?", a: "Oui. Annulez gratuitement jusqu'à 24 heures avant le départ pour un remboursement intégral, ou déplacez votre réservation vers une autre date libre d'un simple message WhatsApp." },
      { q: "Que se passe-t-il si la météo se dégrade ?", a: "La sécurité avant tout. Si le capitaine ou le guide annule pour cause de météo, vous choisissez : nouvelle date, autre excursion ou remboursement intégral le jour même. Vous ne perdrez jamais votre argent." },
      { q: "Comment utiliser le bon QR ?", a: "Il suffit de le montrer sur votre téléphone au point de rendez-vous. Rien à imprimer, aucune paperasse. L'équipage le scanne et vous embarquez." },
    ],
  },
  footer: {
    tagline: "Excursions en petits groupes sur la côte sud de Tenerife, organisées par ceux qui y vivent.",
    contact: "Contact",
    whatsapp: "Discuter sur WhatsApp",
    call: "Appelez-nous",
    email: "E-mail",
    payments: "Nous acceptons",
    hours: "Ouvert tous les jours de 08h00 à 21h00",
    built: "Conçu et réalisé par",
    rights: "Tous droits réservés.",
    legal: "Tour-opérateur agréé · Enregistré à Santa Cruz de Tenerife",
  },
  mobile: { from: "Dès", book: "Réserver" },
};
export default fr;
